// Third party
import {
  FeaturesListAllForSearchFiltersDocument,
  FeaturesListAllForSearchFiltersQuery,
} from '@gql';

// Utils
import { createApolloClient } from '../apollo-node-client';

export const imperativeNodeFeaturesListAllForSearchFiltersQuery = async () => {
  const apolloClient = createApolloClient();

  return await apolloClient.query<FeaturesListAllForSearchFiltersQuery>({
    query: FeaturesListAllForSearchFiltersDocument,
  });
};
